export const SERVICE_REQUEST_LIST_TXT = []
SERVICE_REQUEST_LIST_TXT["en"] = "Service Request List"
SERVICE_REQUEST_LIST_TXT["th"] = "รายการ Service Request"

export const REFERENCE_CODE_TXT = []
REFERENCE_CODE_TXT["en"] = "Request Number"
REFERENCE_CODE_TXT["th"] = "หมายเลข Request"

export const SEQ_WORK_TYPE_NAME_TXT = []
SEQ_WORK_TYPE_NAME_TXT["en"] = "Seq Work Type Name"
SEQ_WORK_TYPE_NAME_TXT["th"] = "ชื่อประเภทงาน"

export const CONTRACT_UNIT_TYPE_TXT = []
CONTRACT_UNIT_TYPE_TXT["en"] = "Contract Unit Type"
CONTRACT_UNIT_TYPE_TXT["th"] = "ประเภท Unit"

export const SERVICE_REQUEST_LIST_Status_TXT = []
SERVICE_REQUEST_LIST_Status_TXT["en"] = "Status : "
SERVICE_REQUEST_LIST_Status_TXT["th"] = "สถานะ : "

export const REQUEST_DATE_TXT = []
REQUEST_DATE_TXT["en"] = "Request Date : "
REQUEST_DATE_TXT["th"] = "วันที่ Request : "

export const SERVICE_REQUEST_LIST_More_TXT = []
SERVICE_REQUEST_LIST_More_TXT["en"] = "See More"
SERVICE_REQUEST_LIST_More_TXT["th"] = "ดูเพิ่มเติม"

export const REQUEST_NO_TXT = []
REQUEST_NO_TXT["en"] = "Request No : "
REQUEST_NO_TXT["th"] = "หมายเลขคำขอ : "

export const PERCENT_OF_PROGRESS_TXT = []
PERCENT_OF_PROGRESS_TXT["en"] = "% Progress : "
PERCENT_OF_PROGRESS_TXT["th"] = "% ความคืบหน้า : "

export const SERVICE_REQUEST_LIST_DETAIL_TXT = []
SERVICE_REQUEST_LIST_DETAIL_TXT["en"] = "Detail : "
SERVICE_REQUEST_LIST_DETAIL_TXT["th"] = "รายละเอียด : "

export const PRINT_DOCUMENT_TXT = []
PRINT_DOCUMENT_TXT["en"] = "Print Document"
PRINT_DOCUMENT_TXT["th"] = "พิมพ์เอกสาร"

export const HISTORY_TXT = []
HISTORY_TXT["en"] = "History"
HISTORY_TXT["th"] = "ประวัติ"

export const INSPECTION_DATE_TXT = []
INSPECTION_DATE_TXT["en"] = "Inspection Date : "
INSPECTION_DATE_TXT["th"] = "วันที่ตรวจสอบ : "

export const OPERATION_DATE_TXT = []
OPERATION_DATE_TXT["en"] = "Operation Date : "
OPERATION_DATE_TXT["th"] = "วันที่ดำเนินงาน : "

export const CLOSE_DATE_TXT = []
CLOSE_DATE_TXT["en"] = "Close Date : "
CLOSE_DATE_TXT["th"] = "วันที่ปิดงาน : "

export const CLOSE_REQUEST_TXT = []
CLOSE_REQUEST_TXT["en"] = "Close Request"
CLOSE_REQUEST_TXT["th"] = "ปิดงาน"

export const FAILED_CLOSE_TICKET_TXT = []
FAILED_CLOSE_TICKET_TXT["en"] = "Failed to Close Ticket"
FAILED_CLOSE_TICKET_TXT["th"] = "ปิดงานไม่สำเร็จ'"

export const SUCCESS_CLOSE_TICKET_TXT = []
SUCCESS_CLOSE_TICKET_TXT["en"] = "Successfully Closed Ticket"
SUCCESS_CLOSE_TICKET_TXT["th"] = "ปิดงานสำเร็จ"